import React from "react"
import Opener from "../pre-opener"
import { t, currentLanguage, Language } from "../i18n"
import { Helmet } from "react-helmet"

export default () => (
  <>
    <Helmet>
      <meta property="og:url" content="https://moondisaster.org/" />
      <meta property="og:title" content={t("opener.meta.title")} />
      <meta property="og:description" content={t("opener.meta.description")} />
      <meta
        property="og:image:secure_url"
        content="https://da.moondisaster.org/wp-content/uploads/2020/07/ieomdPromoNoDate-1200x630-cropped.jpg"
      />
      <meta
        property="og:image:url"
        content="https://da.moondisaster.org/wp-content/uploads/2020/07/ieomdPromoNoDate-1200x630-cropped.jpg"
      />
      <meta
        property="og:image"
        content="https://da.moondisaster.org/wp-content/uploads/2020/07/ieomdPromoNoDate-1200x630-cropped.jpg"
      />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:image:alt" content={t("opener.meta.imageAlt")} />
      <meta
        property="article:author:name"
        content={t("opener.meta.authorName")}
      />
      <meta name="twitter:title" content={t("opener.meta.title")} />
      <meta name="twitter:description" content={t("opener.meta.description")} />
      <meta name="twitter:creator" content={t("opener.meta.authorName")} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:image"
        content="https://da.moondisaster.org/wp-content/uploads/2020/07/ieomdPromoNoDate-1200x854.jpg?p=1806"
      />
      <meta name="twitter:image:alt" content={t("opener.meta.imageAlt")} />
      <meta itemProp="name" content={t("opener.meta.title")} />
      <meta itemProp="description" content={t("opener.meta.description")} />
      <meta name="author" content={t("opener.meta.authorName")} />
      <meta name="description" content={t("opener.meta.description")} />
      <meta
        name="thumbnail"
        content="https://da.moondisaster.org/wp-content/uploads/2020/07/ieomdPromoNoDate-1200x630-cropped.jpg"
      />
    </Helmet>
    <Opener />
  </>
)
